module.exports = __webpack_public_path__ + "static/media/perplexity.194fc192.svg";